import { ComponentProps } from "../registry";
import { useBound, writePath } from "../helpers";
import { BoundString, BoundValue } from "../../types";

export function TextField({ fields, scope }: ComponentProps) {
  const label = useBound<string>(fields.label as BoundValue, scope);
  const value = useBound<string>(fields.text as BoundValue, scope) ?? "";
  const type  = useBound<string>(fields.textFieldType as BoundValue, scope) ?? "shortText";
  const pattern = useBound<string>(fields.validationRegexp as BoundValue, scope);

  const text = fields.text as BoundString | undefined;
  const path = text?.path;

  const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (path) writePath(path, e.target.value);
  };

  const inputClass = "a2-field-input";
  return (
    <label className="a2-field">
      {label && <span className="a2-field-label">{label}</span>}
      {type === "longText" ? (
        <textarea className={inputClass} rows={4} value={value} onChange={onChange} />
      ) : (
        <input
          className={inputClass}
          type={
            type === "obscured" ? "password" :
            type === "number"   ? "number"   :
            type === "date"     ? "date"     : "text"
          }
          pattern={pattern ?? undefined}
          value={value}
          onChange={onChange}
        />
      )}
    </label>
  );
}
